import React from 'react';
import NavBar from '../components/NavBar';
import './DilEgitimPage.css';
import dilImg from '../assets/dil.png';

import q1 from '../assets/q1.jpeg';
import q2 from '../assets/q2.jpeg';
import q3 from '../assets/q3.jpeg';
import q4 from '../assets/q4.jpeg';

export default function DilEgitimPage() {
  const images = [q1, q2, q3, q4];

  return (
    <>
      <NavBar />

      <section id="dil-egitim-page" className="dil-egitim-page">
        {/* Hero */}
        <div className="hero">
          <img src={dilImg} alt="Dil Eğitim Programı" className="hero-img" />
          <div className="overlay" />
          <h1 className="hero-title">Dil Eğitim Programı</h1>
        </div>

        {/* İçerik */}
        <div className="content">
          <h2>Dil Eğitim Programı</h2>
          <p>
            Ülkemizde yabancı dil öğrenmek ve içselleştirmek konusunda ciddi sorunlar yaşandığını biliyoruz.
            Dil edinimi doğal olarak gerçekleştiğinde ve çocukların hayatının bir parçası haline geldiğinde kalıcı olabiliyor.
            Dil edinimi çocukların kendisini güvende hissedebileceği özgür ve yaratıcı bir ortam gerektirir.
            Okulumuz, geleneksel dil öğrenimi yaklaşımı yerine çocukların ihtiyaç ve ilgilerine dayanan bütünlüklü,
            doğaçlama temelli ve özgün etkinlikler barındıran bir dil gelişim programı ve ortamı sağlar.
          </p>
          <p>
            Derslerimizde ezberci yaklaşımlar yerine oyunlar, projeler, diyaloglar, tartışmalar,
            hikâyeler ve öğrencilerin kendi ilgi alanlarından yola çıkan etkinlikler yer alır.
            Öğrencilerin dersin gidişatına aktif katılım göstermesi, süreçte sorumluluk alması
            ve kendi öğrenme yolculuklarını şekillendirmesi bizim için esastır.
          </p>
          <p>
            İngilizceyi yalnızca sınavlardan yüksek not almak için değil, yaşamın içinde kendimizi
            ve başkalarını anlamak, farklı kültürlerle bağ kurmak ve dünyaya daha açık bireyler
            olmak için bir yaşam becerisi olarak görüyoruz.
          </p>
          <p>
            Bu süreçte dikkat ettiğimiz temel ilke ise şuydu; “Dersin sadece öğretmeni değil,
            öğrencisi de aktörüdür.” Her öğrencinin derse katkı sunduğu, kendi öğrenme sürecini
            şekillendirdiği yapı sayesinde öğrenciler İngilizceyi bir “ders” olmaktan çıkarıp
            “yaşam diline” dönüştürmeye başladı.
          </p>
        </div>

        {/* Görsel Galeri */}
        <div className="images-grid">
          {images.map((src, idx) => (
            <img key={idx} src={src} alt={`Dil Eğitim ${idx + 1}`} />
          ))}
        </div>
      </section>
    </>
  );
}
